import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "/mnt/f/Users/sGerli/Development/rebble/rebble-store/build/sprite_module.conf.js";
var symbol = new SpriteSymbol({
  "id": "iconThumbsUp",
  "use": "iconThumbsUp-usage",
  "content": "<symbol class=\"icon-thumbs-up\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"iconThumbsUp\">\r\n  <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" transform=\"translate(-4 -2)\">\r\n    <polygon stroke-width=\"2\" points=\"6.269 9.971 14.201 9.721 17.191 6.189 18.046 3.839 20.696 4.804 21.001 7.043 18.104 11.926 23.643 13.942 23.951 15.622 22.473 17.157 22.772 18.862 21.375 20.174 19.927 21.999 17.664 24.984 14.832 25.224 10.797 23.756 5.763 19.98 3.461 17.686\" transform=\"rotate(-20 13.706 14.532)\" />\r\n    <path d=\"M22.5,14.5 L15.5,14.5\" />\r\n    <polyline points=\"16.5 11 14.5 12.5 15.5 14.5 14.5 15.5 14.5 17 14 19 14.5 20.5 14 21.5 14.5 23.5\" />\r\n    <path d=\"M15 17.5L21.5 17.5M14.5 20.5L20.5 20.5\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ThumbsUp.svg
// module id = VNJ8
// module chunks = 1